export default __webpack_public_path__ + "static/media/map.f6d69880.svg";